import React from 'react';
import { Hero } from './components/Hero';
import { Context } from './components/sections/Context';
import { Problem } from './components/sections/Problem';
import { Process } from './components/sections/Process';
import { Collaboration } from './components/sections/Collaboration';
import { Craft } from './components/sections/Craft';
import { Shipped } from './components/sections/Shipped';
import { Outcome } from './components/sections/Outcome';
import { Reflections } from './components/sections/Reflections';
import { SignOff } from './components/sections/SignOff';
export function App() {
  return <div className="w-full bg-mist" data-id="element-0" data-mp="31b8lg3ugklbu">
      <main className="mx-auto w-[1200px] bg-white" data-id="element-1" data-mp="31c9uk2rwyxqx">
        <Hero data-id="element-2" data-mp="2wjgqzi86lvgf" />
        <Context data-id="element-3" data-mp="2wjql9i09eorx" />
        <Problem data-id="element-4" data-mp="2wj8g1vvmd07v" />
        <Process data-id="element-5" data-mp="2wip36tktt20p" />
        <Collaboration data-id="element-6" data-mp="2wi5qbra193tj" />
        <Craft data-id="element-7" data-mp="28tw4wqgqei2x" />
        <Shipped data-id="element-8" data-mp="28te21azkd5m1" />
        <Outcome data-id="element-9" data-mp="28sutulzptvl7" />
        <Reflections data-id="element-10" data-mp="28sbcb6dz997p" />
        <SignOff data-id="element-11" data-mp="23vci6nubd29i" />
      </main>
    </div>;
}